module.exports = __webpack_public_path__ + "img/MenuButton_LMB.cfc315c5.png";